import "@fortawesome/fontawesome-pro/js/fontawesome";
import "@fortawesome/fontawesome-pro/js/solid";
import "@fortawesome/fontawesome-pro/js/duotone";
